var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.099 1.42188H2.89648C2.21615 1.42188 1.66602 1.98584 1.66602 2.68311V17.6572C1.66602 18.3545 2.21615 18.9219 2.89648 18.9219H17.099C17.7793 18.9219 18.3327 18.3545 18.3327 17.6606V2.68311C18.3327 1.98584 17.7793 1.42188 17.099 1.42188ZM6.61068 16.3345H4.13672V7.98096H6.61068V16.3345ZM5.3737 6.84277C4.57943 6.84277 3.93815 6.16943 3.93815 5.33887C3.93815 4.5083 4.57943 3.83496 5.3737 3.83496C6.16471 3.83496 6.80599 4.5083 6.80599 5.33887C6.80599 6.16602 6.16471 6.84277 5.3737 6.84277ZM15.8685 16.3345H13.3978V12.2739C13.3978 11.3066 13.3815 10.0591 12.112 10.0591C10.8262 10.0591 10.6309 11.1152 10.6309 12.2056V16.3345H8.16341V7.98096H10.5332V9.12256H10.5658C10.8945 8.46631 11.7018 7.77246 12.903 7.77246C15.4063 7.77246 15.8685 9.50195 15.8685 11.751V16.3345Z",
    fill: "#01151C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dd5869c19bfee786e387c34b46d4888e.svg";
export { ForwardRef as ReactComponent };